import { BlastEvent, SimulationConfig } from '../../../types';

export type BlastAnimationFunction = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number,
  timeSeconds: number,
  clampX: (x: number) => number,
  clampY: (y: number) => number,
  globalHue: number,
  cam?: { x: number, y: number, scale: number },
  width?: number,
  height?: number
) => void;

export const BLAST_ANIMATIONS: Record<string, BlastAnimationFunction> = {};

export function registerBlastAnimation(name: string, fn: BlastAnimationFunction) {
  BLAST_ANIMATIONS[name] = fn;
}
